export function multiplyMinorByMultiplier(minor: string, multiplier: number): string {
    if (!Number.isFinite(multiplier) || multiplier <= 0) {
      throw new Error(`Invalid multiplier: ${multiplier}`);
    }
  
    const multiplierText = multiplier.toString();
  
    if (!multiplierText.includes(".")) {
      return (BigInt(minor) * BigInt(multiplierText)).toString();
    }
  
    const [wholePartRaw, fractionalPartRaw = ""] = multiplierText.split(".");
    const wholePart = wholePartRaw || "0";
    const fractionalPart = fractionalPartRaw.replace(/0+$/, "");
  
    if (fractionalPart.length === 0) {
      return (BigInt(minor) * BigInt(wholePart)).toString();
    }
  
    const scale = BigInt(10 ** fractionalPart.length);
    const normalizedMultiplier = BigInt(`${wholePart}${fractionalPart}`);
  
    return ((BigInt(minor) * normalizedMultiplier) / scale).toString();
  }